import { Proposal } from "cap/capTypes";

const addToolTips = ({
  barData,
  production,
  isFlexMonthly,
  baselineProduction,
  useMonthlyEnergyBaseline = false,
}: {
  barData: { month: string; value: number }[];
  production: number[];
  isFlexMonthly: boolean;
  baselineProduction: number[];
  useMonthlyEnergyBaseline?: boolean;
}) => {
  const year = new Date().getFullYear();
  return barData.map(({ value, month }, idx) => {
    const label = createToolTip(
      value,
      production[idx],
      month,
      year,
      isFlexMonthly,
      baselineProduction[idx],
      useMonthlyEnergyBaseline
    );
    return { value, month, label };
  });
};

const createToolTip = (
  usage: number,
  production: number,
  month: string,
  year: number,
  isFlexMonthly: boolean,
  baselineProduction: number,
  useMonthlyEnergyBaseline = false
): string[] => {
  const formattedProduction = Math.round(production).toLocaleString();
  const formattedBaseline = Math.round(baselineProduction).toLocaleString();

  const formattedUsage = Math.round(usage).toLocaleString();
  if (isFlexMonthly) {
    const baselineLabel = useMonthlyEnergyBaseline
      ? "Monthly energy baseline"
      : "Base solar production";
    return [
      `${month} ${year} Estimated`,
      " ",
      `• Sunrun Flex production ${formattedProduction} kWh`,
      `• ${baselineLabel} ${formattedBaseline} kWh`,
      `• Energy usage ${formattedUsage} kWh`,
    ];
  } else {
    return [
      `${month} ${year} Estimated`,
      " ",
      `• Est. solar production ${formattedProduction} kWh`,
      `• Est. energy usage ${formattedUsage} kWh`,
    ];
  }
};

const getProductionFromProposal = (
  proposal: Proposal | undefined
): number[] => {
  return ((proposal || {}).monthlySolarProduction || "")
    .replace(/[{}]/g, "")
    .split(",")
    .map((production) => Number(production) || 0);
};

const getBaselineProductionFromProposal = (
  proposal: Proposal | undefined
): number[] => {
  const usageOffsetFactor = (proposal?.usageOffset || 100) / 100.0;
  return getProductionFromProposal(proposal).map(
    (production) => production / usageOffsetFactor
  );
};

const addSelfSupplyToolTips = ({
  barData,
  selfSupply,
  utilityImport,
}: {
  barData: { month: string; value: number }[];
  selfSupply: number[];
  utilityImport: number[];
}) => {
  const year = new Date().getFullYear();
  return barData.map(({ value, month }, idx) => {
    return {
      value,
      month,
      label: [`${month} ${year} Estimated`],
      selfSupply: selfSupply[idx],
      utilityImport: utilityImport[idx],
    };
  });
};

export {
  addToolTips,
  addSelfSupplyToolTips,
  getProductionFromProposal,
  getBaselineProductionFromProposal,
};
